import { FeatureFlag } from '@/stores/FeatureFlags/types'

export interface FeatureFlagsState {
  featureFlags: Record<FeatureFlag, boolean>
  loaded: boolean
}
export default {
  featureFlags: {},
  loaded: false,
}
